import Axios from 'axios';
import qs from 'qs';
import { vueEnv } from '@/globals';
import store from '@/store';

export const getStudentDbBaseURL = () =>
  (vueEnv('studentdb_api_url') || 'http://localhost:8787').replace(/\/$/, '');

const applyAuthToken = (config, token) => {
  config.headers = config.headers || {};
  config.headers['Authorization'] = `Bearer ${token}`;
};

const handle401 = async (error, instance) => {
  const { config } = error;
  if (config._retry) return Promise.reject(error);
  config._retry = true;
  store.commit('studentdb/clearToken');
  try {
    const token = await store.dispatch('studentdb/fetchToken');
    if (!token) return Promise.reject(error);
    applyAuthToken(config, token);
    return instance(config);
  } catch {
    return Promise.reject(error);
  }
};

const handle409 = (response) => {
  const err = new Error(response.data?.message || 'Workflow conflict');
  err.status = 409;
  err.data = response.data;
  return Promise.reject(err);
};

const studentdbApi = () => {
  const instance = Axios.create({
    baseURL: getStudentDbBaseURL(),
    withCredentials: false,
    paramsSerializer: (params) =>
      qs.stringify(params, { encode: false, arrayFormat: 'repeat' }),
  });

  instance.interceptors.request.use(async (config) => {
    const token = await store.dispatch('studentdb/fetchToken');
    if (token) applyAuthToken(config, token);
    return config;
  });

  instance.interceptors.response.use(
    (response) => response.data,
    async (error) => {
      const { response } = error;
      if (response?.status === 401) return handle401(error, instance);
      if (response?.status === 409) return handle409(response);
      return Promise.reject(error);
    }
  );

  return instance;
};

export default studentdbApi;
